import{ Metrics } from './Metrics'


declare const GLOBAL_Environment:Environment
declare const GLOBAL_BaseURL:string
declare const GLOBAL_BaseApiURL:string
// declare const GLOBAL_BaseApiURL_Direct:string
declare const GLOBAL_AppClipsCapability:string
declare const GLOBAL_ShouldLaunchApp:boolean
declare const GLOBAL_ShouldLaunchAppClip:boolean
declare const GLOBAL_ShouldAppClipsLaunchViaAppleLinks:boolean
declare const GLOBAL_AppURL:string|null
declare const GLOBAL_AppClipURL:string|null

//
// region constants
//

export const environment:Environment = GLOBAL_Environment
export const BaseURL:string = GLOBAL_BaseURL
export const BaseApiURL:string = GLOBAL_BaseApiURL
export const appClipsCapability:AppClipsCapability = GLOBAL_AppClipsCapability as AppClipsCapability
export const ShouldLaunchApp:boolean = GLOBAL_ShouldLaunchApp
export const ShouldLaunchAppClip:boolean = GLOBAL_ShouldLaunchAppClip
export const ShouldAppClipsLaunchViaAppleLinks:boolean = GLOBAL_ShouldAppClipsLaunchViaAppleLinks

// endregion


//
// region operations
//

export function getCookie( name:string ):string {
	const name_:string = `${name}=`
	const allCookies:string[] = decodeURIComponent( document.cookie ).split( ';' )
	let cval:string[] = []
	for( let i = 0; i < allCookies.length; i++ )
		if( allCookies[i].trim().indexOf( name_ ) == 0 )
			cval = allCookies[i].trim().split( '=' )

	return (0 < cval.length) ? cval[1] : ''
}


export async function launchApp() : Promise<void> {
	if( GLOBAL_AppURL == null ){
		console.error( `Unspecified app URL` )
		return
	}
	console.debug( `Launching app at ${GLOBAL_AppURL}...` )
	await Metrics.flush() // NOTE: ensures on-load metrics are sent up (needed for attribution of customer journey)
	// A2
	window.location.href = GLOBAL_AppURL
	// A1
	// window.location.assign( GLOBAL_AppURL )
}
export async function launchAppClip() : Promise<void> {
	if( GLOBAL_AppClipURL == null ){
		console.error( `Unspecified App Clip URL` )
		return
	}
	console.debug( `Launching App Clip at ${GLOBAL_AppClipURL}...` )
	await Metrics.flush() // NOTE: ensures on-load metrics are sent up (needed for attribution of customer journey)
	// A2
	window.location.href = GLOBAL_AppClipURL
	// A1
	// window.location.assign( GLOBAL_AppClipURL )
}

export function debounce<F extends (...args: Parameters<F>) => ReturnType<F>>(
	fn:F, delayMs:number,
): (...args: Parameters<F>) => void {
	let timeout: ReturnType<typeof setTimeout>

	return (...args: Parameters<F>): void => {
		if( timeout )
			clearTimeout( timeout )
		timeout = setTimeout( () => fn( ...args ), delayMs )
	}
}

export const DEBUG_delay = (ms:number) =>
	new Promise( res => setTimeout( res, ms ))


// TODO(arch): can we group this into a helper (ie: ViewUtils)
export class ViewUtils {

	public static observeElements = ({
			elements,
			onIntersect = () => {},
			onLeave = () => {},
		}: {
			elements:HTMLElement[]
			onIntersect?:(entry:IntersectionObserverEntry ) => void,
			onLeave?:(entry:IntersectionObserverEntry) => void,
		},
		options:IntersectionObserverInit = {
			root: null,
			rootMargin: '0px',
			threshold: 0.1
		}
	) => {
		const observer = new IntersectionObserver(
			(entries:IntersectionObserverEntry[]) => {
				if( 1 < entries.length )
					console.debug( `WARNING: Expected a single entry to be intersected but got ${entries.length} instead` )
				
				entries.forEach( (entry:IntersectionObserverEntry) => {
					if( entry.isIntersecting ){
						onIntersect( entry ) // Trigger the callback when the element intersects
					} else {
						onLeave( entry )
					}
				})
			},
			options
		)

		// observe each element
		elements.forEach( (element:HTMLElement) => observer.observe( element ))

		// return a cleanup function to disconnect the observer
		return () => observer.disconnect()
	}
	
	
	public static performWhenScrollingIntoView( elementOrElements:HTMLElement|HTMLElement[], callback:() => void,
		options:IntersectionObserverInit = {}
	){
		this.performWhenScrollingWithinView( elementOrElements, true, callback, options )
	}
	public static performWhenScrollingOutOfView( elementOrElements:HTMLElement|HTMLElement[], callback:() => void,
		options:IntersectionObserverInit = {}
	){
		this.performWhenScrollingWithinView( elementOrElements, false, callback, options )
	}
	public static performWhenScrollingWithinView( elementOrElements:HTMLElement|HTMLElement[], uponBecomingVisible:boolean = true,
		callback:(observerEntry?: IntersectionObserverEntry) => void, options:IntersectionObserverInit = {}
	){
		this.observeElements({
			elements: (elementOrElements instanceof HTMLElement) ? [elementOrElements] : elementOrElements,
			onIntersect: uponBecomingVisible ? callback : undefined,
			onLeave: uponBecomingVisible ? undefined : callback,
		}, options )
	}
}

// endregion


//
// region outer structures
//
export enum Environment {
	Production = 'Production',
	Staging = 'Staging',
	Development = 'Development',
}


export enum AppClipsCapability {
	None = 'None',
	Partial = 'Partial',
	Full = 'Full',
}


export interface CoreError {
	ErrorCode:string
	Message:string
}


export class EnumHelper {
	
	// check if value is valid member of enum
	public static includes<TEnum>( enumObj:TEnum, value:string ): boolean {
		return Object.values( enumObj as any ).includes( value )
	}
	

	// convert string value to enum value
	public static parse<TEnum>( enumObj:TEnum, value:string|undefined ): TEnum[keyof TEnum]|undefined {
		if( !value || !this.includes( enumObj, value ))
			return undefined
		
		return value as TEnum[keyof TEnum]
	}
	
}

// endregion
